class Project {
    constructor() {
        this.config = null;
    }

    async load() {
        const response = await fetch("/project/config.json");

        this.config = await response.json();

        console.log(this.config);

        return this.config;
    }
}

export default new Project();
